if($('#organisation-field').length){
    var app = new Vue({
        el: '#organisation-field',
        data: {
            organisations:[],
            visible:false,
            organisation:currentOrganisation
        },
        props:['currentOrganisation'],
        methods: {
            getOrganisations(search){
                axios.get('/api/v1/organisations-list?search='+search)
                .then((response) =>  {
                    if(response.data.length){
                        this.visible = true;
                        this.organisations = response.data;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
            },
            debounceInput: _.debounce(function (e) {
                let search = e.target.value;
                if(search){
                    if(search.length >= 3){
                        this.getOrganisations(search);
                    }else{
                        this.visible = false;
                        this.organisations = [];
                    }
                }else{
                    this.visible = false;
                    this.organisations = [];
                }
            }, 500),
            selectOrganisation(option){
                console.log(option);
                this.organisation = option;
                this.visible = false;
            },
            hideOnNextTick(){
                setTimeout(() => {
                    this.visible = false;
                }, 250);
            }
        }
    });
}